



































import { Component, Vue } from 'vue-property-decorator';
import MountainBox from '@/components/MountainBox.vue';
import Logo from '@/components/Logo.vue';
import { onLogin } from '@/utils/vue-apollo';
import currentUnitStore from '@/utils/current-unit-store';
import Locale from '@/utils/locale';

@Component({
  components: {
    MountainBox,
    Logo,
  },
})

export default class ConfirmRegistration extends Vue {
  private mounted() {
    this.confirmRegistration();
  }

  private errorMessage = null as string | null;
  private tokenExpired = false;
  private successullyRequestNewRegisterToken = false;
  private serverHost: string | undefined = process.env.VUE_APP_API_HTTP;

  private async confirmRegistration() {
    const registrationToken = this.$route.query.token;

    if (!registrationToken) {
      this.errorMessage = this.$t('Account.registrationTokenMissing') as string;
      return;
    }

    try {
      const response = await fetch(`${this.serverHost}/accounts/confirm_registration`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          registration_token: registrationToken,
          locale: Locale.get(),
        }),
      });

      if (response.status === 200) {
        const payload = await response.json();
        this.login(payload.token);
      } else {
        const payload = await response.json();
        if (payload.error === 'token_expired') {
          this.tokenExpired = true;
        } else {
          this.errorMessage = this.$t('Error.somethingWentWrong') as string;
        }
      }
    } catch (error) {
      this.errorMessage = this.$t('Error.somethingWentWrong') as string;
    }
  }

  private async requestNewRegistrationToken() {
    const oldRegistrationToken = this.$route.query.token;

    if (!oldRegistrationToken) {
      this.errorMessage = this.$t('Account.registrationTokenMissing') as string;
      return;
    }

    try {
      const response = await fetch(`${this.serverHost}/accounts/request_new_registration_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          old_registration_token: oldRegistrationToken,
          locale: Locale.get(),
        }),
      });

      if (response.status === 200) {
        this.successullyRequestNewRegisterToken = true;
      } else {
        this.errorMessage = this.$t('Error.somethingWentWrong') as string;
      }
    } catch (error) {
      this.errorMessage = this.$t('Error.somethingWentWrong') as string;
    }
  }

  public login(token: string): void {
    onLogin(token).then(() => {
      currentUnitStore.remove();
      this.$router.push({ name: 'Dashboard' });
    });
  }
}
